import React, { useState } from 'react'
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import { useTranslation } from 'react-i18next';


const Contact = () => {

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [mail, setmail] = useState("");
  const [massages, setMassages] = useState("");
  const [mother, setMother] = useState("");
  const [school, setSchool] = useState("");
  const [study, setStudy] = useState("");
  const [transport, setTransport] = useState("");
  const [gender, setGender] = useState("");
  const [birth, setBirth] = useState("");

  const nameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const schoolChange = (e) => {
    const value = e.target.value;
    setSchool(value);
  };
  const birthChange = (e) => {
    const value = e.target.value;
    setBirth(value);
  };
  const genderChange = (e) => {
    const value = e.target.value;
    setGender(value);
  };
  const studyChange = (e) => {
    const value = e.target.value;
    setStudy(value);
  };
  const transportChange = (e) => {
    const value = e.target.value;
    setTransport(value);
  };

  const mobileChange = (e) => {
    const value = e.target.value;
    setMobile(value);
  };
  const mailChange = (e) => {
    const value = e.target.value;
    setmail(value);
  };
  const massagesChange = (e) => {
    const value = e.target.value;
    setMassages(value);
  };
  const motherChange = (e) => {
    const value = e.target.value;
    setMother(value);
  };




  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
       
        "service_oumku8k",
        "template_wuxrxj4",
        "#myForm",
        "8i7i_APkS7sZ9CqPl"
      )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          if (response.text === "OK") {
            setName("");
            setMobile("");
            setmail("");
            setMassages("");
            setMother("");
            setSchool("");
            setStudy("");
            setTransport("");
            setGender("");
            setBirth("");
          }
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };
  const { t } = useTranslation();

  return (

    <>
      <section className='' style={{ overflow: "hidden" }}>
        <section className="inner-banner">
          <h1 className="fw-bold text-center" style={{ color: "rgb(95, 45, 237)" }}> {t('Contact')}</h1>
        </section>

        <div className="contact__section sp_top_100 sp_bottom_50" data-aos="fade-up">
          <div className="container">
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="single__contact">
                  <div className="contact__icon">
                    <svg width={64} height={64} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_342_4736)">
                        <rect width={64} height={64} fill="white" />
                        <path d="M63.6998 20.3413L54.4316 13.7947V4.23233C54.3387 3.28509 53.609 2.52481 52.6663 2.39346H12.0633C11.1207 2.52495 10.3908 3.28509 10.2979 4.23233V13.7211L0.662001 20.3411C0.280316 20.6182 0.0385768 21.048 0 21.518V56.4572C0.125304 57.4162 0.879946 58.171 1.83888 58.2961H62.8907C63.6998 58.2961 63.994 57.3399 63.994 56.4572V21.5181C63.994 21.0768 64.0675 20.6354 63.6998 20.3413ZM54.4316 17.3254L60.7575 21.6651L54.4316 26.4463V17.3254ZM13.2402 5.33572H51.4894V28.7267L32.3647 43.1437L13.24 28.7267V5.33572H13.2402ZM10.2979 17.2519V26.52L3.97201 21.6653L10.2979 17.2519ZM2.94226 24.681L23.5381 40.2749L2.94226 54.1771V24.681ZM6.47302 55.354L26.0389 42.1875L31.2615 46.1595C31.5571 46.388 31.9177 46.5168 32.2912 46.5272C32.5855 46.5272 32.7326 46.3801 33.0267 46.1595L38.4698 41.9667L58.2565 55.354H6.47302ZM61.0518 53.6623L40.8974 40.1278L61.0518 24.681V53.6623Z" fill="#5F2DED" />
                        <path d="M20.5961 14.898H27.2161C28.0287 14.898 28.6873 14.2394 28.6873 13.4269C28.6873 12.6144 28.0287 11.9557 27.2161 11.9557H20.5961C19.7836 11.9557 19.125 12.6144 19.125 13.4269C19.125 14.2394 19.7836 14.898 20.5961 14.898Z" fill="#5F2DED" />
                        <path d="M20.5961 21.5181H44.1342C44.9467 21.5181 45.6053 20.8595 45.6053 20.047C45.6053 19.2345 44.9467 18.5759 44.1342 18.5759H20.5961C19.7836 18.5759 19.125 19.2345 19.125 20.047C19.125 20.8595 19.7836 21.5181 20.5961 21.5181Z" fill="#5F2DED" />
                        <path d="M45.6052 26.667C45.6052 25.8545 44.9466 25.1959 44.1341 25.1959H20.5961C19.7836 25.1959 19.125 25.8545 19.125 26.667C19.125 27.4796 19.7836 28.1382 20.5961 28.1382H44.1342C44.9466 28.1382 45.6052 27.4796 45.6052 26.667Z" fill="#5F2DED" />
                      </g>
                      <defs>
                        <clipPath id="clip0_342_4736">
                          <rect width={64} height={64} fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="contact__text">
                    <h5> {t('Mail Address')}</h5>
                    <div className="contact__email">
                      <a href='mailto:acsmadhi23614@gmail.com'><p> {t('acsmadhi23614@gmail.com')}</p></a>
                      <br /><br /><br /><br />

                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="single__contact">
                  <div className="contact__icon">
                    <svg width={46} height={60} viewBox="0 0 46 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M38.8868 48.524C37.0927 47.7314 34.7762 47.0908 32.1029 46.6396C32.883 45.8918 33.6807 45.0921 34.4804 44.2431C37.6741 40.8522 40.2225 37.3879 42.0549 33.9461C44.3712 29.5951 45.5457 25.2656 45.5457 21.0781C45.5457 9.45565 35.3298 0 22.7728 0C10.2159 0 0 9.45565 0 21.0781C0 25.2656 1.17445 29.5951 3.49082 33.9462C5.32315 37.388 7.87156 40.8523 11.0653 44.2432C11.8649 45.0922 12.6627 45.8919 13.4428 46.6397C10.7695 47.0909 8.45303 47.7315 6.65891 48.5241C3.24665 50.0313 2.53032 51.7517 2.53032 52.9295C2.53032 54.4209 3.64479 56.5425 8.95365 58.1805C12.6637 59.3252 17.5714 59.9556 22.7728 59.9556C27.9743 59.9556 32.882 59.3252 36.592 58.1805C41.9009 56.5425 43.0154 54.4209 43.0154 52.9295C43.0154 51.7517 42.299 50.0313 38.8868 48.524V48.524ZM2.53032 21.0781C2.53032 10.747 11.6111 2.34201 22.7728 2.34201C33.9346 2.34201 43.0154 10.747 43.0154 21.0781C43.0154 29.7724 37.3572 37.6156 32.6106 42.6642C28.5331 47.0012 24.4062 50.0812 22.7728 51.236C21.1391 50.0808 17.0122 47.0008 12.9351 42.6644C8.18848 37.6156 2.53032 29.7724 2.53032 21.0781V21.0781ZM35.7918 55.9588C32.333 57.0258 27.7095 57.6135 22.7728 57.6135C17.8362 57.6135 13.2127 57.0258 9.75386 55.9588C6.28973 54.89 5.06063 53.6589 5.06063 52.9295C5.06063 51.713 8.35776 49.6179 15.6671 48.6818C16.7496 49.6341 17.7575 50.463 18.6383 51.157C17.2962 51.5861 16.4471 52.2208 16.4471 52.9295C16.4471 54.2235 19.2797 55.2715 22.7728 55.2715C26.2659 55.2715 29.0986 54.2235 29.0986 52.9295C29.0986 52.2208 28.2495 51.5861 26.9074 51.157C27.7882 50.463 28.7961 49.6341 29.8786 48.6818C37.1879 49.6179 40.4851 51.713 40.4851 52.9295C40.4851 53.6589 39.256 54.89 35.7918 55.9588Z" fill="#5F2DED" />
                      <path d="M40.485 21.0781C40.485 12.0384 32.5393 4.68402 22.7728 4.68402C13.0062 4.68402 5.06055 12.0384 5.06055 21.0781C5.06055 30.1178 13.0062 37.4722 22.7728 37.4722C32.5393 37.4722 40.485 30.1178 40.485 21.0781ZM7.59086 21.0781C7.59086 13.3298 14.4015 7.02603 22.7728 7.02603C31.1441 7.02603 37.9547 13.3298 37.9547 21.0781C37.9547 28.8264 31.1441 35.1302 22.7728 35.1302C14.4015 35.1302 7.59086 28.8264 7.59086 21.0781Z" fill="#5F2DED" />
                      <path d="M24.0389 29.2752C24.0389 29.9219 24.6053 30.4462 25.3041 30.4462H30.3647C31.0635 30.4462 31.6299 29.9219 31.6299 29.2752V23.4202H34.1602C34.6855 23.4202 35.1561 23.1198 35.3427 22.6653C35.5293 22.2109 35.3932 21.6969 35.0006 21.3739L23.6142 12.0059C23.1348 11.6115 22.4126 11.6115 21.9332 12.0059L10.5468 21.3739C10.1542 21.6969 10.0181 22.2109 10.2047 22.6653C10.3913 23.1198 10.862 23.4202 11.3873 23.4202H13.9177V29.2752C13.9177 29.9219 14.4841 30.4462 15.1828 30.4462H20.2435C20.9422 30.4462 21.5086 29.9219 21.5086 29.2752V25.7622H24.0389V29.2752ZM20.2435 23.4202C19.5447 23.4202 18.9783 23.9444 18.9783 24.5912V28.1042H16.448V22.2491C16.448 21.6024 15.8816 21.0781 15.1828 21.0781H14.715L22.7738 14.4478L30.8326 21.0781H30.3647C29.666 21.0781 29.0996 21.6024 29.0996 22.2491V28.1042H26.5692V24.5912C26.5692 23.9444 26.0028 23.4202 25.3041 23.4202H20.2435Z" fill="#5F2DED" />
                    </svg>
                  </div>
                  <div className="contact__text">
                    <h5> {t('School Address')}</h5>
                    <div className="contact__email">
                      <p style={{ textAlign: "center" }}> {t('Admire Convent School Madhi, Atariya, Marhi, Madhya Pradesh 486446. (Near by Shark-Inn Hotel)')}</p>
                      {/* <span>Eastbourne Terrace</span> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="single__contact">
                  <div className="contact__icon">
                    <svg width={58} height={58} viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M45.7084 35.8601C44.5233 34.6261 43.0938 33.9664 41.5788 33.9664C40.076 33.9664 38.6343 34.6139 37.4003 35.8479L33.5394 39.6965C33.2218 39.5255 32.9041 39.3667 32.5987 39.2078C32.1588 38.9879 31.7434 38.7802 31.3891 38.5603C27.7726 36.2633 24.486 33.2699 21.3338 29.3969C19.8066 27.4665 18.7803 25.8415 18.035 24.1921C19.0368 23.2757 19.9654 22.3227 20.8695 21.4064C21.2116 21.0643 21.5537 20.71 21.8958 20.3679C24.4616 17.8021 24.4616 14.4789 21.8958 11.9131L18.5603 8.57765C18.1816 8.19889 17.7906 7.80792 17.4241 7.41695C16.691 6.65944 15.9213 5.8775 15.1271 5.14443C13.942 3.97151 12.5247 3.3484 11.0341 3.3484C9.54355 3.3484 8.10184 3.97151 6.88006 5.14443C6.86784 5.15665 6.86784 5.15665 6.85562 5.16886L2.70155 9.35959C1.13766 10.9235 0.24576 12.8295 0.0502747 15.0409C-0.242954 18.6085 0.807782 21.9318 1.61416 24.1065C3.59345 29.4458 6.55018 34.394 10.9608 39.6965C16.3122 46.0865 22.7511 51.1325 30.1062 54.6878C32.9163 56.0196 36.6672 57.5957 40.8579 57.8645C41.1145 57.8767 41.3833 57.8889 41.6277 57.8889C44.45 57.8889 46.8202 56.8748 48.6774 54.8589C48.6896 54.8345 48.714 54.8222 48.7262 54.7978C49.3616 54.0281 50.0946 53.3317 50.8644 52.5864C51.3897 52.0854 51.9273 51.5601 52.4527 51.0103C53.6622 49.7518 54.2976 48.2857 54.2976 46.7829C54.2976 45.2679 53.65 43.8139 52.416 42.5922L45.7084 35.8601ZM50.0824 48.7255C50.0702 48.7255 50.0702 48.7378 50.0824 48.7255C49.6059 49.2387 49.1172 49.703 48.5918 50.2161C47.7977 50.9736 46.9913 51.7678 46.2338 52.6597C44.9998 53.9792 43.5459 54.6023 41.6399 54.6023C41.4566 54.6023 41.2611 54.6023 41.0779 54.5901C37.4491 54.358 34.077 52.9407 31.5479 51.7311C24.6326 48.3834 18.5603 43.6307 13.5144 37.6073C9.34807 32.5857 6.56239 27.943 4.7175 22.9581C3.58124 19.9158 3.16583 17.5456 3.3491 15.3097C3.47128 13.8802 4.02108 12.6951 5.03516 11.681L9.20145 7.51469C9.80013 6.95267 10.4355 6.64723 11.0586 6.64723C11.8283 6.64723 12.4514 7.1115 12.8424 7.50248C12.8546 7.51469 12.8668 7.52691 12.879 7.53913C13.6243 8.23555 14.333 8.9564 15.0782 9.72613C15.457 10.1171 15.848 10.5081 16.2389 10.9113L19.5744 14.2467C20.8695 15.5418 20.8695 16.7392 19.5744 18.0343C19.2201 18.3886 18.878 18.7429 18.5237 19.085C17.4974 20.1357 16.52 21.1132 15.457 22.0662C15.4326 22.0906 15.4081 22.1028 15.3959 22.1273C14.3452 23.178 14.5407 24.2043 14.7606 24.9007C14.7728 24.9374 14.785 24.974 14.7972 25.0107C15.6647 27.1121 16.8865 29.0914 18.7436 31.4495L18.7558 31.4617C22.1279 35.6158 25.6833 38.8535 29.6053 41.3337C30.1062 41.6514 30.6194 41.908 31.1081 42.1523C31.5479 42.3722 31.9633 42.5799 32.3176 42.7999C32.3665 42.8243 32.4154 42.861 32.4643 42.8854C32.8797 43.0931 33.2706 43.1908 33.6738 43.1908C34.6879 43.1908 35.3232 42.5555 35.5309 42.3478L39.7094 38.1693C40.1249 37.7539 40.7846 37.253 41.5543 37.253C42.3119 37.253 42.935 37.7295 43.3137 38.1449C43.3259 38.1571 43.3259 38.1571 43.3382 38.1693L50.0702 44.9013C51.3286 46.1476 51.3286 47.4304 50.0824 48.7255Z" fill="#5F2DED" />
                      <path d="M31.2424 13.7702C34.4435 14.3078 37.3514 15.8228 39.6728 18.1442C41.9942 20.4656 43.497 23.3735 44.0468 26.5746C44.1812 27.3809 44.8776 27.943 45.6717 27.943C45.7695 27.943 45.855 27.9307 45.9527 27.9185C46.8569 27.7719 47.4555 26.9167 47.3089 26.0125C46.6492 22.1395 44.8165 18.6085 42.0186 15.8106C39.2207 13.0127 35.6897 11.1801 31.8167 10.5203C30.9126 10.3737 30.0695 10.9724 29.9107 11.8643C29.7519 12.7562 30.3383 13.6236 31.2424 13.7702Z" fill="#5F2DED" />
                      <path d="M57.7793 25.536C56.6919 19.1583 53.6863 13.3548 49.0679 8.73649C44.4496 4.11814 38.6461 1.11255 32.2684 0.0251576C31.3765 -0.133675 30.5334 0.477218 30.3746 1.36912C30.228 2.27324 30.8267 3.11628 31.7308 3.27511C37.4243 4.24032 42.6169 6.94047 46.7465 11.0579C50.8762 15.1875 53.5641 20.3801 54.5293 26.0736C54.6637 26.88 55.3601 27.442 56.1543 27.442C56.252 27.442 56.3376 27.4298 56.4353 27.4176C57.3272 27.2832 57.9381 26.428 57.7793 25.536Z" fill="#5F2DED" />
                    </svg>
                  </div>
                  <div className="contact__text">
                    <h5> {t('Phone Number')}</h5>
                    <div className="contact__email">
                      <p> <a href='tel:+91 9165355872'>+91 9165355872</a> </p>
                      <p> <a href='tel:+91 7489128284'>+91 7489128284</a> </p><br />
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contact__from__wraper sp_bottom_100">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="contact__form__inner">
                  <div className="contact__form__heading" data-aos="fade-up">
                    <h3> {t('Drop Message')}</h3>
                    <p> {t('Well call you back when you fill out your information')} * </p>
                  </div>
                  <form id="myForm" className="contact-form" action="" method="post" onSubmit={sendEmail}>
                    <div className="row">
                      <div className="col-xl-6" data-aos="fade-up">
                        <div className="contact__input__wraper">
                          <input type="text" name="from_name" placeholder="Name of the child*"
                            onChange={(e) => nameChange(e)}
                            required
                            value={name}

                          />
                          <div className="contact__icon">
                            <i className="icofont-businessman" />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6" data-aos="fade-up">
                        <div className="contact__input__wraper">
                          <input type="text" name="Father's Name" placeholder="Father's Name*"
                            onChange={(e) => massagesChange(e)}
                            value={massages}
                            required



                          />
                          <div className="contact__icon">
                            <i className="icofont-businessman" />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6" data-aos="fade-up">
                        <div className="contact__input__wraper">
                          <input type="text" name="Mother's Name" id="con_name" placeholder="Mother's Name*"
                            onChange={(e) => motherChange(e)}
                            value={mother}
                            required


                          />
                          <div className="contact__icon">
                            <i className="icofont-businessman" />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6" data-aos="fade-up">
                        <div className="contact__input__wraper">
                          <input type="text" name="Name school" id="con_name" placeholder="Name of the school the child is attending*"
                            onChange={(e) => schoolChange(e)}
                            value={school}


                          />
                          <div className="contact__icon">
                            <i className="icofont-businessman" />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6" data-aos="fade-up">
                        <div className="contact__input__wraper">
                          <input type="text" name="Studying" id="con_name" placeholder="Studying in class*"
                            onChange={(e) => studyChange(e)}
                            value={study}


                          />
                          <div className="contact__icon">
                            <i className="icofont-businessman" />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6" data-aos="fade-up">
                        <div className="contact__input__wraper">
                          <input type="text" name="transport" id="con_name" placeholder="If school transport is required*"
                            onChange={(e) => transportChange(e)}
                            value={transport}


                          />
                          <div className="contact__icon">
                            <i className="icofont-businessman" />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6" data-aos="fade-up">

                        <div className="contact__input__wraper">
                          <input type="text" name="Gender" id="con_name" placeholder="Gender (Please put)*"
                            onChange={(e) => genderChange(e)}
                            value={gender}
                            required


                          />
                          <div className="contact__icon">
                            <i className="icofont-businessman" />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6" data-aos="fade-up">

                        <div className="contact__input__wraper">
                          <input type="text" name="Date birth" id="con_name" placeholder="Child Date of birth*"
                            onChange={(e) => birthChange(e)}
                            value={birth}


                          />
                          <div className="contact__icon">
                            <i className="icofont-businessman" />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6" data-aos="fade-up">
                        <div className="contact__input__wraper">
                          <input type="text" name="Your Phone" placeholder="Enter Your Phone"
                            onChange={(e) => mobileChange(e)}
                            value={mobile}
                            required


                          />
                          <div className="contact__icon">
                            <i className="icofont-ui-call" />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6" >
                        <div className="contact__input__wraper">
                          <input type="text" name="Residential" placeholder="Residential Address"
                            onChange={(e) => mailChange(e)}
                            value={mail}
                            required

                          />
                          <div className="contact__icon">
                            <i className="icofont-edit" />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-12" data-aos="fade-up">
                        <div className="contact__button">
                          <button type="submit" value="submit" className="default__button" name="submit">Send Message</button>
                          <p className="form-messege" />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>







        <section className="map container">
          <div className="sec-title text-center mb-3" data-aos="fade-up" data-aos-duration={1000}>
            <h2> {t('Maps')}</h2>
            <div className="divider">
              <span className="fa fa-mortar-board" />
            </div>
          </div>
          <div style={{ maxWidth: '100%', listStyle: 'none', transition: 'none', overflow: 'hidden', width: 1200, height: 400 }}><div id="google-maps-display" style={{ height: '100%', width: '100%', maxWidth: '100%' }}><iframe style={{ height: '100%', width: '100%', border: 0 }} frameBorder={0} src="https://www.google.com/maps/embed/v1/place?q=Admire+Convent+School+Madhi,+Atariya,+Marhi,+Madhya+Pradesh+486446&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8" /></div><a className="embed-map-html" href="https://www.bootstrapskins.com/themes" id="grab-map-data">premium bootstrap themes</a><style dangerouslySetInnerHTML={{ __html: "#google-maps-display img.text-marker{max-width:none!important;background:none!important;}img{max-width:none}" }} /></div>


        </section>
        <br />
        <br />

      </section>
    </>
  )
}

export default Contact